import axios from "axios";
import { Base_URL } from "../url";

export const saveDeduction = async (deductionData) => {
  try {
    console.log(deductionData, "deductionData");
    const response = await axios.post(`${Base_URL}/SalaryProcess/DeductionMaster`, deductionData);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error saving deduction!";
  }
};

export const fetchWorkingDaysIds = async (id) => {
  try {
    const response = await axios.get(`${Base_URL}/SalaryProcess/Working_DaysMaster/id?id=${id}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching working days IDs!";
  }
};

export const fetchResourceIds = async (id) => {
  try {
    const response = await axios.get(`${Base_URL}/SalaryProcess/ResourceMasters/${id}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching resource IDs!";
  }
};